var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalDismissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFAC06",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9975 20.1667C22.9975 18.5558 21.6917 17.25 20.0809 17.25C18.47 17.25 17.1642 18.5558 17.1642 20.1667C17.1642 21.7775 18.47 23.0833 20.0809 23.0833C21.6917 23.0833 22.9975 21.7775 22.9975 20.1667Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9831 20.4583C23.2514 20.5396 23.536 20.5833 23.8308 20.5833C25.4417 20.5833 26.7475 19.2775 26.7475 17.6667C26.7475 16.0558 25.4417 14.75 23.8308 14.75C22.3184 14.75 21.0748 15.9012 20.9286 17.3751",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2331 17.3751C19.0869 15.9012 17.8433 14.75 16.3309 14.75C14.72 14.75 13.4142 16.0558 13.4142 17.6667C13.4142 19.2775 14.72 20.5833 16.3309 20.5833C16.6257 20.5833 16.9103 20.5396 17.1786 20.4583",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4141 24.75C28.4141 22.4488 26.3621 20.5833 23.8308 20.5833",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6641 27.25C24.6641 24.9488 22.6121 23.0833 20.0808 23.0833C17.5495 23.0833 15.4974 24.9488 15.4974 27.25",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3308 20.5833C13.7995 20.5833 11.7474 22.4488 11.7474 24.75",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalDismissed);
export default __webpack_public_path__ + "static/media/total-dismissed.a4ed3011a5117f43334e7d2179b85fd0.svg";
export { ForwardRef as ReactComponent };